import { BULK_ORDER_COATING_FILTERS } from './config'
import { getGridAxis } from './gridAxisUtils'
import { getHasSideSelection } from './sideUtils'

export const getIsAntireflex = characteristics => {
  const { antireflex } = characteristics || {}
  return antireflex != null && antireflex !== 'NONE'
}

export const getIsHard = characteristics => {
  const { hard } = characteristics || {}
  return hard != null && hard !== 'NONE'
}

export const getFilterCoating = characteristics => {
  const isAntireflex = getIsAntireflex(characteristics)
  const isHard = getIsHard(characteristics)

  if (isAntireflex) return BULK_ORDER_COATING_FILTERS.AR
  if (isHard) return BULK_ORDER_COATING_FILTERS.HC
  return BULK_ORDER_COATING_FILTERS.UC
}

export const toCatalogItem = lens => {
  const name = lens.names?.[0]?.long
  if (!name) return null

  const { material, opticalIndex } = lens.materialProperty || {}

  return {
    _id: String(lens._id),
    code: lens.code,
    name,
    material,
    opticalIndex,
    isAntireflex: getIsAntireflex(lens.characteristics),
    isHard: getIsHard(lens.characteristics),
    filterCoating: getFilterCoating(lens.characteristics),
    topology: lens.topology,
    focalType: lens.focalGroup?.focalType,
    gridAxis: getGridAxis(lens.focalGroup?.focalType),
    hasSideSelection: getHasSideSelection(lens.focalGroup?.focalType),
    sorting: lens.sorting,
  }
}
